/**
 * Local, non-customerizable MetricPage constants (dev flags + layout/paging).
 *
 * Customer/domain + product UI config lives in `tpoGenConfig.metricPageConfig`
 * (types in `config/metricPageConfig.ts`) and is consumed via
 * `useTpoGenConfig().metricPageConfig`.
 */

export const USE_DUMMY_METRIC_DATA = false;

export const PAGE_LIMIT = 50;

export const PLAN_ACTION_MENU_KEYS = {
    deletePlan: 'delete_plan',
    deleteAllPromotions: 'delete_all_promotions',
} as const;

if (USE_DUMMY_METRIC_DATA) {
    // eslint-disable-next-line no-console
    console.warn('[MetricView] Using dummy data — flip USE_DUMMY_METRIC_DATA to false before release');
}
